"use client";

import type { GroupResponse } from "@/app/api/types/group";
import type { UUID } from "node:crypto";
import { v2Fetch } from "./client";

interface V2GroupPatch {
  name?: string;
  aiContext?: string | null;
}

interface V2GroupResponse {
  id: string;
  companyId: string;
  ownerId: string;
  name: string;
  aiContext: string | null;
  createdAt: string;
  updatedAt: string;
}

function adaptV2Group(raw: V2GroupResponse): GroupResponse {
  return {
    id: raw.id as UUID,
    name: raw.name,
    owner_id: raw.ownerId as UUID,
    owner_name: null,
    ai_context: raw.aiContext,
    created_at: raw.createdAt,
    updated_at: raw.updatedAt,
    members: [],
  };
}

export async function v2UpdateGroup(
  groupId: string,
  patch: V2GroupPatch,
): Promise<GroupResponse> {
  const raw = await v2Fetch<V2GroupResponse>(`/api/v2/groups/${groupId}`, {
    method: "PATCH",
    body: JSON.stringify(patch),
  });
  return adaptV2Group(raw);
}
